// Generated by ReScript, PLEASE EDIT WITH CARE


let basePathname = "compliance";

let baseRoute = "/" + basePathname;

let verifyCashRegisterArchiveRoute = baseRoute + "/verify-cash-register-archive";

export {
  basePathname,
  baseRoute,
  verifyCashRegisterArchiveRoute,
}
/* No side effect */
